import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18N, GlobalContext } from 'commons';
import FieldSection from 'components/forms/FieldSection';
import DropDownWithLabel from 'components/forms/DropDownWithLabel';
import { PREFERREDLANGUAGENOTPROVIDED } from 'constants/applicationConstant';

const MyProfileSection = ({
  isPreferredLanguageEditable,
  isPreferredLanguageMandatory,
  setFieldValue,
  setFieldTouched,
  setFieldError,
  values, touched, errors, preferredLanguage, preferredLanguageList = {}, isPreferredLanguageExposed
}) => {
  const { organization: { editFirstName, editLastName}, account: { ssoIdentity } } = useContext(GlobalContext);

  return (
    <div className="col-md-12">
      <div className="form-group row">
        <FieldSection
          className="col-md-4"
          name="firstName"
          title="ssp.register.firstname"
          maxLength="100"
          isDisable={!editFirstName}
          autoComplete="given-name"
          {...{ values, touched, errors }}
        />
        <FieldSection
          className="col-md-4"
          name="lastName"
          title="ssp.register.lastname"
          maxLength="100"
          isDisable={!editLastName}
          autoComplete="family-name"
          {...{ values, touched, errors }}
        />
      </div>
      <div className="form-group row">
        <div className="col-md-8">
          {
            (isPreferredLanguageExposed &&
              <DropDownWithLabel
                onChange={event => {
                  setFieldTouched('preferredLanguage', true, true);
                  if (event.target.value === PREFERREDLANGUAGENOTPROVIDED || event.target.value === 'Please select...') {
                    return setFieldValue('preferredLanguage', PREFERREDLANGUAGENOTPROVIDED, true);
                  }
                  return setFieldValue('preferredLanguage', event.target.value, true);
                }}
                handleBlur={(event) => {
                  setFieldTouched('preferredLanguage', true, true);
                  if (event.target.value === PREFERREDLANGUAGENOTPROVIDED || event.target.value === 'Please select...') {
                    return setFieldError('preferredLanguage', 'Preferred language is required.');
                  }
                  return setFieldError('preferredLanguage', '');
                }}
                defaultValue={preferredLanguage}
                field="preferredLanguage"
                testSelector="ssp_myprofile_preferredLanguage"
                label="ssp.register.preferredLanguage"
                list={preferredLanguageList}
                disabled={!isPreferredLanguageEditable}
                mandatory={isPreferredLanguageMandatory && isPreferredLanguageEditable}
                emptyOptionValue={!isPreferredLanguageEditable && PREFERREDLANGUAGENOTPROVIDED || undefined}
                error={touched.preferredLanguage && errors.preferredLanguage}
                shouldShowEmptyOptions={true}
            />)
          }
        </div>
      </div>
    </div>
  );
};

MyProfileSection.propTypes = {
  values: PropTypes.shape().isRequired,
  touched: PropTypes.shape().isRequired,
  errors: PropTypes.shape().isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  setFieldError: PropTypes.func.isRequired,
  isPreferredLanguageEditable: PropTypes.bool,
  isPreferredLanguageMandatory: PropTypes.bool,
  preferredLanguage: PropTypes.string,
};

export default MyProfileSection;
